

import { Component, Vue } from 'vue-property-decorator';
import BaseCabecalho from '@/components/base/BaseCabecalho.vue';
import Rules from '@/shared/utils/rules.util';
import { TransferenciaInterface } from '@/shared/models/transferencia/transferencia.interface';
import TransferenciaService from '@/services/transferencia.service';

@Component({
  components: {
    BaseCabecalho,
  },
})
export default class Transferencia extends Vue {
  public transferencia = {} as TransferenciaInterface;

  public rules = Rules;

  private service = new TransferenciaService();

  async atualizarRegra() {
    if ((this.$refs.form as HTMLFormElement).validate()) {
      await this.service.atualizarRegra(this.transferencia);
    }
  }

  async mounted() {
    this.transferencia = await this.service.getRegra();
  }
}
